import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BudgetState } from 'types';

export const initialState: BudgetState = {
  loading: false,
  budgetList: [],
  territory: 'ATLA-20'
};

const slice = createSlice({
  name: 'budget',
  initialState,
  reducers: {
    setBudgetList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.budgetList = payload || [];
    }
  }
});

export const { setBudgetList } = slice.actions;

export default slice.reducer;
